import {
  getExpandedFavorites,
  setExpandedFavorites as saveExpandedFavorites,
} from "@/lib/uiStatePersistence";
import { useCallback, useEffect, useState } from "react";

/**
 * Custom hook to manage whether the favorites section is expanded in the sidebar
 * with localStorage persistence across page refreshes
 */
export function useExpandedFavorites() {
  const [expandedFavorites, setExpandedFavorites] = useState<boolean>(() => {
    return getExpandedFavorites();
  });

  // Save to localStorage whenever expandedFavorites changes
  useEffect(() => {
    saveExpandedFavorites(expandedFavorites);
  }, [expandedFavorites]);

  // Toggle favorites expanded state
  const toggleFavorites = useCallback(() => {
    setExpandedFavorites((prev) => !prev);
  }, []);

  return {
    expandedFavorites,
    toggleFavorites,
  };
}
